(function (app) {

    app.provider("transactionQuestionApi",
    [
        function () {
            this.$get = [
                "complianceHubApiGateway", function (complianceHubApiGateway) {
                    var service = {};

                    service.getTransactionQuestionCategories = function (transactionId) {
                        return complianceHubApiGateway.getArray("/TransactionQuestionCategories/ForTransaction/" + transactionId);
                    }

                    service.getPublishedTransactionQuestionCategories = function(transactionGroupId) {
                        return complianceHubApiGateway.getArray("/TransactionGroup/" + transactionGroupId + "/PublishedQuestionCategories");
                    }

                    service.createTransactionQuestionCategory = function (transactionQuestionCategory) {
                        return complianceHubApiGateway.post("/TransactionQuestionCategories/", transactionQuestionCategory);
                    }

                    service.createTransactionQuestion = function (question) {
                        return complianceHubApiGateway.post("/TransactionQuestions/", question);
                    }
                   
                    service.updateTextAnswer = function (transactionQuestion) {
                        return complianceHubApiGateway.put("/TransactionQuestions/Text/", transactionQuestion);
                    }

                    service.updateSelectOneAnswer = function (transactionQuestion) {
                        return complianceHubApiGateway.put("/TransactionQuestions/SelectOne/", transactionQuestion);
                    }

                    service.updateSelectManyAnswer = function (transactionQuestion) {
                        return complianceHubApiGateway.put("/TransactionQuestions/SelectMany/", transactionQuestion);
                    }


                    return service;
                }
            ];
        }
    ]);
})(window.app); //jshint ignore:line